/**
 * 스토리지 유틸리티
 * 웹에서는 localStorage를 사용하고, 웹뷰에서는 네이티브 브릿지를 통해 저장할 수 있도록 확장 가능한 구조
 */

const STORAGE_KEY_GUEST_ID = 'dreamity_guest_id'

/**
 * 웹뷰 환경인지 확인
 * 나중에 웹뷰로 전환할 때 window.ReactNativeWebView나 다른 네이티브 브릿지가 있는지 확인
 */
const isWebView = (): boolean => {
  // 웹뷰 환경 감지 로직 (필요에 따라 수정)
  return typeof window !== 'undefined' && 
         (window.ReactNativeWebView !== undefined || 
          (window as any).webkit?.messageHandlers !== undefined ||
          (window as any).Android !== undefined)
}

/**
 * guestId 저장
 * 웹: localStorage 사용
 * 웹뷰: 네이티브 브릿지를 통해 저장 (나중에 구현)
 */
export const saveGuestId = (guestId: string): void => {
  if (isWebView()) {
    // 웹뷰 환경: 네이티브 브릿지를 통해 저장
    // 예: window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'SAVE_GUEST_ID', guestId }))
    // 또는 (window as any).webkit.messageHandlers.saveGuestId.postMessage(guestId)
    // 현재는 localStorage를 fallback으로 사용
    try {
      localStorage.setItem(STORAGE_KEY_GUEST_ID, guestId)
    } catch (error) {
      console.error('guestId 저장 실패:', error)
    }
  } else {
    // 웹 환경: localStorage 사용
    try {
      localStorage.setItem(STORAGE_KEY_GUEST_ID, guestId)
    } catch (error) {
      console.error('guestId 저장 실패:', error)
    }
  }
}

/**
 * guestId 불러오기
 * 웹: localStorage에서 읽기
 * 웹뷰: 네이티브 브릿지를 통해 읽기 (나중에 구현)
 */
export const getGuestId = (): string | null => {
  if (isWebView()) {
    // 웹뷰 환경: 네이티브 브릿지를 통해 읽기
    // 예: 네이티브에서 메시지를 보내주거나, 동기적으로 읽을 수 있는 API 사용
    // 현재는 localStorage를 fallback으로 사용
    try {
      return localStorage.getItem(STORAGE_KEY_GUEST_ID)
    } catch (error) {
      console.error('guestId 읽기 실패:', error)
      return null
    }
  } else {
    // 웹 환경: localStorage에서 읽기
    try {
      return localStorage.getItem(STORAGE_KEY_GUEST_ID)
    } catch (error) {
      console.error('guestId 읽기 실패:', error)
      return null
    }
  }
}

/**
 * guestId 삭제
 */
export const removeGuestId = (): void => {
  if (isWebView()) {
    // 웹뷰 환경: 네이티브 브릿지를 통해 삭제
    // 현재는 localStorage를 fallback으로 사용
    try {
      localStorage.removeItem(STORAGE_KEY_GUEST_ID)
    } catch (error) {
      console.error('guestId 삭제 실패:', error)
    }
  } else {
    // 웹 환경: localStorage에서 삭제
    try {
      localStorage.removeItem(STORAGE_KEY_GUEST_ID)
    } catch (error) {
      console.error('guestId 삭제 실패:', error)
    }
  }
}

